export default function MainSection() {
  return (
    <section className="pt-2 lg:pt-10 lg:px-7 space-y-2">
      <h1 className="w-fit text-4xl lg:text-6xl lg:leading-[1.1] text-gradient text-center font-bold font-gilroy whitespace-pre-wrap lg:whitespace-normal mx-auto">
        Take your digital identity to the next level
      </h1>
      <p className="w-fit text-lg lg:text-[2.1875rem] lg:leading-[1.15] text-gradient-2 text-center font-medium font-gilroy whitespace-pre-wrap lg:whitespace-normal mx-auto">
        New standard for our digital identity and professional communications
      </p>
    </section>
  );
}
